import axios from "axios";
import store from "../store";
import { logoutUser } from "../store/reducers/auth";
import { navigateFunction } from "../utils/navigator";

// const api = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
// });

const api = axios.create(); 

// Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("Interceptor Response -- ", error)
    if (error?.response?.status === 401) {
      sessionStorage.clear();
      store.dispatch(logoutUser());
      navigateFunction("/vkyc/login");
    }
    return Promise.reject(error);
  }
);

export default api;
